import About from "../components/About";
import News from "../components/News";
import Announcement from "../components/Announcement";
import Index from "../components/Index";
import Contact from "../components/Contact";
import Solution from "../components/Solution";
import Newsdetails from "../components/Newsdetails";
import Login from "../components/Login";
import { Navigate } from "react-router-dom";
import Culture from "../components/Culture";
const a = [
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/news",
    element: <News />,
    children: [
      {
        path: "newsdetails/:id",
        element: <Newsdetails />,
      },
    ],
  },
  {
    path: "/announcement",
    element: <Announcement />,
  },
  {
    path: "/index",
    element: <Index />,
    children: [
      {
        path: "newsdetails",
        element: <Newsdetails />,
      },
    ],
  },
  {
    path: "/",
    element: <Navigate to="/index" />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/solution",
    element: <Solution />,
  },
  {
    path: "/Login",
    element: <Login />,
  },
  {
    path:"/Culture",
    element:<Culture/>
  }
];
export default a;
